import React, { useCallback } from 'react';

import Webcam from 'react-webcam';

import Button from '~/components/Button';

const WebcamContent = ({ getScreenshot, setPhoto, label }) => {

    const handleCapture = useCallback(async () => {
        const imageSource = getScreenshot();
        setPhoto(imageSource);
    }, [getScreenshot, setPhoto]);

    return (
        <Button
            onClick={handleCapture}
        >
            {label}
        </Button>
    );
};

const WebcamPicture = ({ setPhoto, label = 'Capturar foto' }) => {
    return (
        <Webcam
            audio={false}
            screenshotFormat="image/png"
        >
            {({ getScreenshot }) => (
                <WebcamContent
                    getScreenshot={getScreenshot}
                    setPhoto={setPhoto}
                    label={label}
                />
            )}
        </Webcam>
    );
};

export default WebcamPicture;
